import React from 'react';
import ClipLoader from "react-spinners/ClipLoader";


const Spinners = () => (
    <ClipLoader color={"lightgreen"}/>
);

export default Spinners;